<template>
  <b-container>
    <div class="merchant-heading">
      <h2>Merchants</h2>
    </div>
    <v-data-table
      :headers="headers"
      :items="merchants"
      item-class="table-rows"
      :loading="merchantsLoading"
      class="elevation-1 pr-t-class"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.merchantName`]="{ item }">
        <span
          class="merchant-nav"
          @click="
            $router.push(
              `/administration/merchant-details/${item.merchantName}`
            )
          "
          >{{ item.merchantName }}</span
        >
      </template>
    </v-data-table>
  </b-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { getMerchantsData } from "../../../../graphql/queries";
export default {
  data() {
    return {
      merchants: [],
      merchantsLoading: false,
      headers: [
        { text: "Name", value: "merchantName" },
        { text: "Signup", value: "signUpDate" },
        { text: "Next Payment", value: "nextPaymentDate" },
        { text: "Last Payment", value: "lastPaymentDate" },
        { text: "Email", value: "contactEmail" }
      ]
    };
  },

  methods: {
    async updateMerchants() {
      try {
        this.merchantsLoading = true;
        const { data } = await API.graphql(graphqlOperation(getMerchantsData));
        if (data.getMerchantsData.error || !data.getMerchantsData.success)
          throw new Error("Something went wrong fetching merchants");

        this.merchants = data.getMerchantsData.data;
        this.merchantsLoading = false;
      } catch (error) {
        this.createToast("danger", error?.message ?? "Something went wrong");
        this.merchantsLoading = false;
        this.$logger.error(error);
      }
    },
    createToast(variant, message) {
      this.$bvToast.toast(message, {
        title: "List Merchants Table",
        autoHideDelay: 5000,
        variant,
        append: true
      });
    }
  },

  async mounted() {
    await this.updateMerchants();
  }
};
</script>
<style scoped>
.merchant-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
}
.merchant-nav {
  color: #5454ff;
  cursor: pointer;
  font-size: 1rem;
}
</style>
